import React from "react";
import Navbar from "./Navbar";
function ResponsiveNavbar() {
  return (
    <>
      <Navbar />
    </>
  );
}

export default ResponsiveNavbar;
